import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import { validateEmail } from 'helpers/validations'
import { Tabs, TabLink, TabContent, TabButton } from 'components/tabs'
import Modalizer from 'components/modalizer/modalizer'
import ShareEmail from './share_email/share_email'
import ShareSocial from './share_social/share_social'
import ShareLink from './share_link/share_link'
import ShareEmbed from './share_embed/share_embed'
import { shareRemind } from 'helpers/social/remind'
import generalActions from 'redux/actions/generalActions'
import shareActions from 'redux/actions/shareActions'
import shareLessonSelector from 'redux/selectors/share/share_lesson_selector'
import GoogleSlidesLessonShareConfirm from './confirms/google_slides_share_confirm'
import lessonSources from 'helpers/enums/lessonSources'

import styles from './share.scss'

class Share extends Component {

	constructor(props) {
		super(props)
		let checkboxValue = null
		const emailTemplates = []
		let toggableKey = ''
		///
		if (props.share && props.share.payload) {
			checkboxValue = false
			if (props.share.payload.email) {
				const emailLinkOptions = props.share.payload.email.emailLinkOptions || []
				const keys = Object.keys(emailLinkOptions)
				keys.forEach(key => {
					if (!emailLinkOptions[key].visible) {
						emailTemplates.push(key)
					} else {
						toggableKey = key
					}
				})
				if (emailLinkOptions.editableLink) {
					checkboxValue = emailLinkOptions.editableLink.default
				} else if (emailLinkOptions.specialEditableLink) {
					checkboxValue = emailLinkOptions.specialEditableLink.default
				}
			}
		}
		///
		this.emailTemplates = emailTemplates
		this.toggableKey = toggableKey
		this.state = {
			checkbox: checkboxValue,
			isConfirmed: props.entityType !== 'lesson' ||
				props.entity.data.sourceInfo.type !== lessonSources.GOOGLE_SLIDES,
		}
		this.handleShareEntityEmbed = this.handleShareEntity.bind(this, 'Embed')
	}

	isTabVisible(tab, selectedMainTab) {
		return (selectedMainTab===tab)?true:false
	}

	handleEmailSubmit(values) {
		return new Promise((resolve, reject) => {
			if (!validateEmail(values.email)) {
				const errorMessage = localize('share_invalid_email')
				this.props.actions.openMessage(
					{
						alertImage: 'ic_share',
						alertTitle: errorMessage,
						singleButton: true,
						alertMessage: values.email,
						buttons: [
							{
								buttonName: 'OK',
							},
						],
					},
					'alert')
				reject()
			} else {
				const templates = [...this.emailTemplates]
				if (values.checkbox) {
					templates.push(this.toggableKey)
				}

				this.handleShareEntity('Email', values.email.split(',').length)
				this.props.actions.sendShareEmailForm(values.email, this.props.entityUID, this.props.entityType,
					this.props.libraryID, templates)
				resolve()
			}
		})
	}

	getExternalClient() {
		let sharingUrl = 'mailto:?'
		const emailData = this.props.share.payload.email
		if (this.props.entityType === 'lesson' && this.state.checkbox) {
			sharingUrl+='subject='+encodeURIComponent(emailData.subject_copy_plain || emailData.subject_plain)
			sharingUrl+='&body='+encodeURIComponent(emailData.message_copy_plain || emailData.message_plain)
		} else {
			sharingUrl+='subject='+encodeURIComponent(emailData.subject_plain)
			sharingUrl+='&body='+encodeURIComponent(emailData.message_plain)
		}
		return sharingUrl
	}

	getExternalOutlook() {
		let sharingUrl = 'https://outlook.live.com/owa/?path=/mail/action/compose'
		const emailData = this.props.share.payload.email
		if (this.props.entityType === 'lesson' && this.state.checkbox) {
			sharingUrl+='&subject='+encodeURIComponent(emailData.subject_copy_plain || emailData.subject_plain)
			sharingUrl+='&body='+encodeURIComponent(emailData.message_copy_plain || emailData.message_plain)
		} else {
			sharingUrl+='&subject=' + encodeURIComponent(emailData.subject_plain)
			sharingUrl+='&body=' + encodeURIComponent(emailData.message_plain)
		}
		return sharingUrl
	}

	getExternalGmail() {
		let sharingUrl = 'https://mail.google.com/mail/?view=cm&fs=1&shva=1&ui=2&tf=1'
		const emailData = this.props.share.payload.email
		if (this.props.entityType === 'lesson' && this.state.checkbox) {
			sharingUrl+='&su='+encodeURIComponent(emailData.subject_copy_plain || emailData.subject_plain)
			sharingUrl+='&body='+encodeURIComponent(emailData.message_copy_plain || emailData.message_plain)
		} else {
			sharingUrl+='&su='+encodeURIComponent(emailData.subject_plain)
			sharingUrl+='&body='+encodeURIComponent(emailData.message_plain)
		}
		return sharingUrl
	}

	getExternalYahoo() {
		const emailData = this.props.share.payload.email
		let message = '', subject = ''
		if (this.props.entityType === 'lesson' && this.state.checkbox) {
			subject = (emailData.subject_copy_plain || emailData.subject_plain).replace(/'/g, ' ')
			message = (emailData.message_copy_plain || emailData.message_plain).replace(/'/g, ' ')
		} else {
			subject = emailData.subject_plain.replace(/'/g, ' ')
			message = emailData.message_plain.replace(/'/g, ' ')
		}
		subject = subject.replace(/"/g, ' ')
		subject = subject.replace(/¨/g, ' ')
		subject = subject.replace(/\n/g, ' ')

		message = message.replace(/"/g, ' ')
		message = message.replace(/¨/g, ' ')
		message = message.replace(/\n/g, ' ')


		let sharingUrl = 'http://compose.mail.yahoo.com/?'
		sharingUrl+='subject='+encodeURIComponent(subject)
		sharingUrl+='&body='+encodeURIComponent(message)
		return sharingUrl
	}

	getExternalLink = type => {
		if (this.state.checkbox === null) {
			return ''
		}
		if (type === 'gmail') {
			return this.getExternalGmail()
		} else if (type === 'yahoo') {
			return this.getExternalYahoo()
		} else if (type === 'outlook') {
			return this.getExternalOutlook()
		} else if (type === 'client') {
			return this.getExternalClient()
		}
		return 'https://github.com'
	}

	buildEmailCheckboxOption() {
		let checkboxData
		if (this.props.share.payload.email && this.props.share.payload.email.emailLinkOptions && this.toggableKey) {
			const emailLinkOptions = this.props.share.payload.email.emailLinkOptions
			checkboxData = {
				default: emailLinkOptions[this.toggableKey].default,
				text: emailLinkOptions[this.toggableKey].text,
			}
		}
		return checkboxData
	}

	emailFormChanged = values => {
		if (this.state.checkbox !== values.checkbox && values.checkbox !== undefined) {
			this.setState({
				checkbox: !!values.checkbox,
			})
		}
	}

	handleShareEntity = (source, count = 1) => {
		this.props.actions.shareEntity(this.props.entityType, this.props.entityUID, source, count)
	}

	handleShareEntityLink = (isEditableLink = false, editableLinkAvailable = false) => {
		this.props.actions.shareEntityLink(this.props.entityType, this.props.entityUID, isEditableLink, editableLinkAvailable)
	}

	shareRemindHandler = () => {
		this.handleShareEntity('Remind')
		shareRemind(this.props.share.payload.remind.url, this.props.share.payload.remind.text)
	}

	onShareConfirm = () => {
		this.setState({
			isConfirmed: true,
		})
	}

	render() {
		if (this.props.share.payload && !this.state.isConfirmed) {
			return (
				<GoogleSlidesLessonShareConfirm
					onCancel={() => this.props.actions.closeModal(this.props.modalName)}
					onConfirm={this.onShareConfirm}
				/>
			)
		} else if (this.props.share.payload) {

			const checkboxData = this.buildEmailCheckboxOption()

			return (
				<Modalizer nopadding={true} closeAction={() => this.props.actions.closeModal(this.props.modalName)}>

					<h3 styleName='title'>{this.props.share.payload.title ? this.props.share.payload.title : localize('share_title')}</h3>

					<div styleName='main'>

						<Tabs name='main_share'
							handleSelect={
								(selectedTab, namespace) => {
									this.props.actions.changeTab(selectedTab, namespace)
								}
							}
							selectedTab={this.props.share.selectedMainTab}
							activeLinkStyle={{}}
							activeClassStyle={styles.active_tab_item}>

							<div styleName='tab'>
								{this.props.share.payload.email &&
									<TabLink to='email' styleName='tab_item'><div className={styles.share_email}>{localize('share_email')}</div></TabLink>
								}
								{this.props.share.payload.social &&
									<TabLink to='social' styleName='tab_item'><div className={styles.share_social}>{localize('share_social')}</div></TabLink>
								}
								{this.props.share.payload.link &&
									<TabLink to='link' styleName='tab_item'><div className={styles.share_link}>{localize('share_link')}</div></TabLink>
								}
								{this.props.share.payload.embed &&
									<TabLink to='embed' styleName='tab_item'><div className={styles.share_embed}>{localize('share_embed')}</div></TabLink>
								}
								{this.props.share.payload.remind &&
									<TabButton onClick={this.shareRemindHandler} styleName='tab_item'>
										<div className={styles.share_remind}>{localize('share_remind')}</div>
									</TabButton>
								}
							</div>
							<div styleName='content'>
								{this.props.share.payload.email &&
									<TabContent for='email'>
										<ShareEmail
											onChange={this.emailFormChanged}
											visibleTab={this.isTabVisible('email', this.props.share.selectedMainTab)}
											onFormSubmit={this.handleEmailSubmit.bind(this)}
											getExternalLink={this.getExternalLink}
											checkboxData={checkboxData}
											emailHint={this.props.share.payload.emailHint}
											onSelect={this.handleShareEntity} />
									</TabContent>
								}
								{this.props.share.payload.social &&
									<TabContent for='social'>
										<ShareSocial
											visibleTab={this.isTabVisible('social', this.props.share.selectedMainTab)}
											dataObject={this.props.share.payload.social}
											onSelect={this.handleShareEntity} />
									</TabContent>
								}
								{this.props.share.payload.link &&
									<TabContent for='link'>
										<ShareLink
											visibleTab={this.isTabVisible('link', this.props.share.selectedMainTab)}
											payload={this.props.share.payload.link}
											onSelect={this.handleShareEntityLink}
											shouldShowEditableUrl={!!checkboxData}
											previewLinkLabel={localize('share_link_view_only')}
											editableLinkLabel={localize('share_link_editable')}
										/>
									</TabContent>
								}
								{this.props.share.payload.embed &&
									<TabContent for='embed'>
										<ShareEmbed
											visibleTab={this.isTabVisible('embed', this.props.share.selectedMainTab)}
											onTabChange={(selectedTab, namespace) => {
												this.props.actions.changeTab(selectedTab, namespace)
											}}
											selectedEmbedRadio={this.props.share.selectedEmbedRadio}
											payload={this.props.share.payload.embed}
											onSelect={this.handleShareEntityEmbed} />
									</TabContent>
								}
							</div>
						</Tabs>

					</div>

				</Modalizer>
			)
		} else {
			return null
		}
	}

}

Share.propTypes = {
	tab: PropTypes.string,
	share: PropTypes.object,
	closeEvent: PropTypes.func,
	entityType: PropTypes.string,
	actions: PropTypes.shape({
		openMessage: PropTypes.func.isRequired,
		sendShareEmailForm: PropTypes.func.isRequired,
		closeModal: PropTypes.func.isRequired,
		changeTab: PropTypes.func.isRequired,
		shareEntity: PropTypes.func.isRequired,
		shareEntityLink: PropTypes.func.isRequired,
	}),
	entityUID: PropTypes.string,
}

Share.defaultProps = {
	tab: 'email',
	entityType: 'default',
}

function mapStateToProps(state, props) {
	return shareLessonSelector(state, props)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		openMessage: generalActions.openMessage,
		sendShareEmailForm: shareActions.sendShareEmailForm,
		closeModal: generalActions.closeModal,
		changeTab: generalActions.changeTab,
		shareEntity: shareActions.shareEntity,
		shareEntityLink: shareActions.shareEntityLink,
	}, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Share, styles, {allowMultiple: true}))
